import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const handleSubmit = async () => {
    setError('');
    if (!email) return setError('Introduce tu email');
    setLoading(true);
    try {
      await forgotPassword({ email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al procesar la solicitud');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: isMobile ? '2rem 1rem' : '4rem 2rem' }}>
        <div style={{ width: '100%', maxWidth: '420px' }}>
          <h1 style={{ color: colors.text, fontSize: isMobile ? '1.6rem' : '1.8rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>¿Olvidaste tu contraseña?</h1>
          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', marginBottom: '2rem' }}>
            Introduce tu email y te enviaremos un enlace para restablecerla.
          </p>

          {sent ? (
            <div style={{ backgroundColor: '#00cc6622', border: '1px solid #00cc66', color: '#00cc66', padding: '1rem', borderRadius: '8px', fontSize: '0.9rem' }}>
              Si el email está registrado, recibirás un enlace para restablecer tu contraseña en unos minutos. Revisa también tu carpeta de spam.
            </div>
          ) : (
            <>
              {error && <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.8rem 1rem', borderRadius: '8px', marginBottom: '1.5rem', fontSize: '0.85rem' }}>{error}</div>}
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Email</label>
                <input
                  style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.8rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
                  type="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                />
              </div>
              <button
                style={{ backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.9rem', borderRadius: isMobile ? '4px' : '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', width: '100%', textTransform: isMobile ? 'uppercase' : 'none', letterSpacing: isMobile ? '0.05em' : 'normal' }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar enlace'}
              </button>
            </>
          )}

          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', textAlign: 'center', marginTop: '1.5rem' }}>
            <Link to="/login" style={{ color: colors.accent, textDecoration: 'none', fontWeight: 'bold' }}>Volver a iniciar sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;